import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export type RequestQuotePayload = {
  regardingOpportunityId: string;
  quoteId: string;
};

export const requestQuote = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (payload: RequestQuotePayload) => {
      return fetchWithAuth("requestQuote", undefined, {
        requestOptions: {
          method: "post",
          body: JSON.stringify(payload),
        },
      });
    },
    onMutate: defaultOnMutateSuccess(options),
  });
};
